export default __webpack_public_path__ + "static/media/grain-noise.961d7bb2.png";